import projectData from 'ProjectData/project.json'
import axios from 'axios'

const state = {
  scenes: [],
  currentScene: {},
  sceneLoaded: false
}

const getters = {
  getState (state) {
    return state.scenes
  },
  getCurrentScene (state) {
    return state.currentScene
  },
  getsceneLoaded (state) {
    return state.sceneLoaded
  },
  getScene: (state) => (sceneuid) => {
    return state.scenes.find(scene => scene.sceneuid === sceneuid)
  }
}

const actions = {
  async fetchData ({ commit }) {
    const response = await axios.get(projectData)
    commit('setState', response.data.scenes)
  },
  setCurrentScene ({ commit }, {scene}) {
    commit('setCurrentScene', scene)
  },
  setSceneLoaded ({ commit }) {
    commit('setLoadedState', true)
  },
  setSceneLoading ({ commit }) {
    commit('setLoadedState', false)
  }
}

const mutations = {
  setState (state, scenes) {
    state.scenes = scenes
  },
  setCurrentScene (state, scene) {
    state.currentScene = scene
  },
  setLoadedState (state, loadState) {
    state.sceneLoaded = loadState
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
